import React from "react";
import './Loading.css';

export const Loading = () => <div className="loading">
  <div className="lds-dual-ring"></div>
</div>
